(function() {
    angular.module("app").controller("NoticeDeleteModalController", NoticeDeleteModalController)

    NoticeDeleteModalController.$inject = [
        "$scope",
        "$uibModalInstance",
        "selectedNotice",
        "deleteNotice"

    ]

    function NoticeDeleteModalController(
        $scope,
        $uibModalInstance,
        selectedNotice,
        deleteNotice

    ){
        "use strict"

        $scope.notice = {
            title:      selectedNotice.title,
            publish_on: moment(selectedNotice.publish_on).format("MMMM Do, YYYY")
        }

        $scope.delete = () => {
            $uibModalInstance.close(deleteNotice(selectedNotice.id))
        }

        $scope.cancel = () => {
            $uibModalInstance.dismiss("cancel")
        }


    }
})()
